import { render, staticRenderFns } from "./PaxelRecycleBanner.vue?vue&type=template&id=e664bfde&"
import script from "./PaxelRecycleBanner.vue?vue&type=script&lang=js&"
export * from "./PaxelRecycleBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports